import { useEffect, useState } from "react";
import { Utils } from "../../../utils";

export function PresidentStep(props) {
  const formContainer = "presidents-form-container";
  const associes = JSON.parse(props.associes);

  const [nombreGerant, setNombreGerant] = useState("");
  const [president, setPresident] = useState(props?.president);
  const [stated, setStated] = useState("celibataire");

  const [presidentType, setPresidentType] = useState("");
  Utils.Auth.getUser();

  const handleInputChange = (name, value) => {
    let presidentCopy = { ...president };
    if (value === "marie") {
      setStated("marie");
    }
    if (name === "associe-president") {
      presidentCopy = { "associe-president": "oui", ...JSON.parse(value) };
    } else {
      presidentCopy["type"] = "particulier";
      presidentCopy[name] = value;
    }

    setPresident(presidentCopy);
  };

  const handleTypePresidentChange = (value) => {
    setPresident({});

    const formContainerElem = window.document.querySelector(
      `#${formContainer}-0`
    );
    Array.from(formContainerElem.querySelectorAll(".field")).forEach(
      (field) => (field.value = "")
    );

    setPresidentType(value);
  };
  const handleStepSubmit = (e) => {
    e.preventDefault();

    if (!president) return alert("Vous devez remplir le formulaire !");
    president["fait-partie-des-associes"] = presidentType;
    props.handleNextClick(e, "presidents", JSON.stringify([president]));
  };

  useEffect(() => {
    if (!nombreGerant) return;
  }, [nombreGerant]);

  return (
    <div
      className={`grid grid-cols-12 gap-4 row-gap-5 col-span-12 
        ${props.step !== props.index ? "hidden" : ""}`}
    >
      <small className="intro-y col-span-12">
        Indiquez les informations relatives
        {props.demande === "commerciale" || props.demande === "civile"
          ? " à l'Administration"
          : " aux président"}
      </small>
      <div className="intro-y col-span-12" id={`${formContainer}-0`}>
        <div className={`mb-2 `}>
          {props.demande === "commerciale" || props.demande === "civile"
            ? "L'administration"
            : "Le président"}{" "}
          fait-il partie des associés ?
        </div>
        <div className="flex flex-col sm:flex-row mt-4 mb-2">
          <div className="flex items-center text-gray-700 dark:text-gray-500 mr-2">
            <input
              type="radio"
              className="input border mr-2"
              id={`horizontal-radio-oui-0`}
              name={`president-0`}
              value="oui"
              checked={president['fait-partie-des-associes'] === 'oui'}
              onChange={(e) => handleTypePresidentChange("oui")}
            />
            <label
              className="cursor-pointer select-none"
              htmlFor={`horizontal-radio-oui-0`}
            >
              Oui
            </label>
          </div>
          <div
            className="flex items-center text-gray-700 dark:text-gray-500 
                        mr-2 mt-2 sm:mt-0"
          >
            <input
              type="radio"
              className="input border mr-2"
              id={`horizontal-non-0`}
              name={`president-0`}
              value="non"
              checked={president['fait-partie-des-associes'] === 'non'}
              onChange={(e) => handleTypePresidentChange("non")}
            />
            <label
              className="cursor-pointer select-none"
              htmlFor={`horizontal-non-0`}
            >
              Non
            </label>
          </div>
        </div>
        <div
          className={`grid grid-cols-12 gap-4 row-gap-5 col-span-12 
                    ${
                      presidentType !== undefined && presidentType === "oui"
                        ? ""
                        : "hidden"
                    }`}
        >
          <div className="intro-y col-span-12 sm:col-span-6">
            <div className="my-2">
              Lequel des associés est il
              {props.demande === "commerciale" || props.demande === "civile"
                ? " à l'administration"
                : " le président"}
              ?
            </div>
            <select
              type="text"
              className="input w-full border flex-1 field"
              onChange={(e) =>
                handleInputChange("associe-president", e.target.value)
              }
            >
              {associes.map((associe, index) => {
                return (
                  <option value={JSON.stringify(associe)} key={index}>
                    {Utils.Demande.getAssocieName(associe)}
                  </option>
                );
              })}
            </select>
          </div>
          <div className="intro-y col-span-12 sm:col-span-6">
            <div className="mb-2">
              Nom & prénom du père{" "}
              {props.demande === "commerciale" || props.demande === "civile"
                ? "de l'administrateur"
                : "du président"}
            </div>
            <input
              type="text"
              className="input w-full border flex-1 field"
              placeholder="Nom"
              value={president['nom-pere']}
              onChange={(e) => handleInputChange("nom-pere", e.target.value)}
            />
            <div className="intro-y col-span-12 sm:col-span-6">
              <div className="mb-2">
                nom & prénom de la mère{" "}
                {props.demande === "commerciale" || props.demande === "civile"
                  ? "de l'administrateur"
                  : "du président"}
              </div>
              <input
                type="text"
                className="input w-full border flex-1 field"
                placeholder="Prenom"
                value={president['nom-mere']}
                onChange={(e) => handleInputChange("nom-mere", e.target.value)}
              />
            </div>
          </div>
        </div>
        <div
          className={`grid grid-cols-12 gap-4 row-gap-5 col-span-12 
                    ${
                      presidentType !== undefined && presidentType === "non"
                        ? ""
                        : "hidden"
                    }`}
        >
          <div className="intro-y col-span-12 sm:col-span-6">
            <div className="mb-2">
              Numéro de votre pièce d’identité{" "}
              <small>
                (les anciennes pièces ne sont pas prises en compte )
              </small>
            </div>
            <input
              type="text"
              className="input w-full border flex-1 field"
              placeholder=" Numéro de votre pièce d’identité"
              value={president['numero-piece-identite']}
              onChange={(e) =>
                handleInputChange("numero-piece-identite", e.target.value)
              }
            />
          </div>
          <div className="intro-y col-span-12 sm:col-span-6">
            <div className="my-2">Type de la piece d'identité</div>
            <select
              type="text"
              className="input w-full border flex-1 field"
              value={president['type-piece-identite']}
              onChange={(e) =>
                handleInputChange("type-piece-identite", e.target.value)
              }
            >
              <option value="CNI">CNI</option>
              <option value="Passport">Passport</option>
              <option value="Attestation d'identité">
                Attestation d'identité
              </option>
              <option value="Titre de séjour">Titre de séjour</option>
              <option value="Carte de résident">Carte de résident</option>
              <option value="Autres">Autres</option>
            </select>
          </div>
          <div className="intro-y col-span-12 sm:col-span-6">
            <div className="my-2">Pays de délivrance de la pièce</div>
            <input
              type="text"
              className="input w-full border flex-1 field"
              placeholder="Pays de délivrance de la pièce"
              value={president['pays-piece-identite']}
              onChange={(e) =>
                handleInputChange("pays-piece-identite", e.target.value)
              }
            />
          </div>
          <div className="intro-y col-span-12 sm:col-span-6">
            <div className="my-2">Date d’établissement de la pièce</div>
            <input
              type="date"
              className="input w-full border flex-1 field"
              placeholder="Date d’établissement de la pièce"
              value={president['date-piece-identite']}
              onChange={(e) =>
                handleInputChange("date-piece-identite", e.target.value)
              }
            />
          </div>
          <div className="intro-y col-span-12 sm:col-span-6">
            <div className="my-2">Date de validité de la pièce</div>
            <input
              type="date"
              className="input w-full border flex-1 field"
              placeholder="Date de validité de la pièce"
              value={president['date-fin-validite-piece-identite']}
              onChange={(e) =>
                handleInputChange(
                  "date-fin-validite-piece-identite",
                  e.target.value
                )
              }
            />
          </div>
          <div className="intro-y col-span-12 sm:col-span-6">
            <div className="my-2">Civilité</div>
            <select
              type="text"
              value={president['civilite']}
              className="input w-full border flex-1 field"
              onChange={(e) => handleInputChange("civilite", e.target.value)}
            >
              <option value="monsieur">Monsieur</option>
              <option value="madame">Madame</option>
              <option value="mademoiselle">Mademoiselle</option>
            </select>
          </div>
          <div className="intro-y col-span-12 sm:col-span-6">
            <div className="my-2">Nationalité</div>
            <input
              type="text"
              value={president['nationalite']}
              className="input w-full border flex-1 field"
              placeholder="Nationalité"
              onChange={(e) => handleInputChange("nationalite", e.target.value)}
            />
          </div>
          <div className="intro-y col-span-12 sm:col-span-6">
            <div className="my-2">Adresse</div>
            <input
              type="text"
              value={president['adresse']}
              className="input w-full border flex-1 field"
              placeholder="Adresse"
              onChange={(e) => handleInputChange("adresse", e.target.value)}
            />
          </div>
          <div className="intro-y col-span-12 sm:col-span-6">
            <div className="mb-2">Nom</div>
            <input
              type="text"
              value={president['nom']}
              className="input w-full border flex-1 field"
              placeholder="Nom"
              onChange={(e) => handleInputChange("nom", e.target.value)}
            />
          </div>
          <div className="intro-y col-span-12 sm:col-span-6">
            <div className="mb-2">Prenom</div>
            <input
              type="text"
              value={president['prenoms']}
              className="input w-full border flex-1 field"
              placeholder="Prenom"
              onChange={(e) => handleInputChange("prenoms", e.target.value)}
            />
          </div>
          <div className="intro-y col-span-12 sm:col-span-6">
            <div className="mb-2">Numéro de téléphone</div>
            <input
              type="text"
              className="input w-full border flex-1 field"
              placeholder="Numéro de téléphone"
              value={president['numero-telephone']}
              onChange={(e) =>
                handleInputChange("numero-telephone", e.target.value)
              }
            />
          </div>
          <div className="intro-y col-span-12 sm:col-span-6">
            <div className="mb-2">Date de naissance</div>
            <input
              type="date"
              className="input w-full border flex-1 field"
              placeholder="Date de naissance"
              value={president['date-naissance']}
              onChange={(e) =>
                handleInputChange("date-naissance", e.target.value)
              }
            />
          </div>
          <div className="intro-y col-span-12 sm:col-span-6">
            <div className="mb-2">Pays de naissance</div>
            <input
              type="text"
              className="input w-full border flex-1 field"
              placeholder="Pays de naissance"
              value={president['pays-naissance']}
              onChange={(e) =>
                handleInputChange("pays-naissance", e.target.value)
              }
            />
          </div>

          <div className="intro-y col-span-12 sm:col-span-6">
            <div className="mb-2">Lieu de naissance</div>
            <input
              type="text"
              className="input w-full border flex-1 field"
              placeholder="Lieu de naissance"
              value={president['lieu-naissance']}
              onChange={(e) =>
                handleInputChange("lieu-naissance", e.target.value)
              }
            />
          </div>

          <div className="intro-y col-span-6 sm:col-span-6">
            {/* <div className="mb-2">Nationalité</div> */}
            <div className="mb-4">Situation matrimoniale</div>
            <div className="flex flex-col sm:flex-row mb-2 col-span-6">
              <div className="flex items-center text-gray-700 dark:text-gray-500 mr-2">
                <input
                  type="radio"
                  className="input border mr-2 field"
                  id={`horizontal-radio-celibataire`}
                  name={`associe-situation-matrimoniale`}
                  value="celibataire"
                  checked={president['situation-matrimoniale']==="celibataire"}
                  onChange={(e) =>
                    handleInputChange(
                      "situation-matrimoniale",
                      "celibataire",
                      e.target.value
                    )
                  }
                />
                <label
                  className="cursor-pointer select-none"
                  htmlFor={`horizontal-radio-celibataire`}
                >
                  Célibataire
                </label>
              </div>
              <div className="flex items-center text-gray-700 dark:text-gray-500 mr-2 mt-2 sm:mt-0">
                <input
                  type="radio"
                  className="input border mr-2 field"
                  id={`horizontal-radio-marie`}
                  name={`associe-situation-matrimoniale`}
                  value="marie"
                  checked={president['situation-matrimoniale']==="marie"}
                  onChange={(e) =>
                    handleInputChange(
                      "situation-matrimoniale",
                      "marie",
                      e.target.value
                    )
                  }
                />
                <label
                  className="cursor-pointer select-none"
                  htmlFor={`horizontal-radio-marie`}
                >
                  Marié-e
                </label>
              </div>
            </div>
          </div>

          <div
            className={`intro-y col-span-6 ${
              stated !== undefined && stated === "marie" ? "" : "hidden"
            }`}
          >
            <div className="col-span-6  mb-4">Régime matrimonial </div>
            <div className="flex flex-col sm:flex-row mb-2 col-span-6">
              <div className="flex items-center text-gray-700 dark:text-gray-500 mr-2">
                <input
                  type="radio"
                  className="input border mr-2 field"
                  id={`horizontal-radio-communaute-de-bien`}
                  name={`associe-regime-matrimonial`}
                  value="communaute-de-bien"
                  checked={president['regime-matrimonial']==="Communaute de bien"}
                  onChange={(e) =>
                    handleInputChange(
                      "regime-matrimonial",
                      "Communaute de bien",
                      e.target.value
                    )
                  }
                />
                <label
                  className="cursor-pointer select-none"
                  htmlFor={`horizontal-radio-communaute-de-bien`}
                >
                  Communauté de bien
                </label>
              </div>
              <div className="flex items-center text-gray-700 dark:text-gray-500 mr-2 mt-2 sm:mt-0">
                <input
                  type="radio"
                  className="input border mr-2 field"
                  id={`horizontal-radio-separation-de-bien`}
                  name={`associe-regime-matrimonial`}
                  value="separation-de-bien"
                  checked={president['regime-matrimonial']==="Séparation de bien"}
                  onChange={(e) =>
                    handleInputChange(
                      "regime-matrimonial",
                      "Séparation de bien",
                      e.target.value
                    )
                  }
                />
                <label
                  className="cursor-pointer select-none"
                  htmlFor={`horizontal-radio-separation-de-bien`}
                >
                  Séparation de bien
                </label>
              </div>
            </div>
          </div>

          <div className="intro-y col-span-12 sm:col-span-6">
            <div className="mb-2">
              Nom & Prénom(s) du père
              {props.demande === "commerciale" || props.demande === "civile"
                ? " de l'Administration"
                : " du président"}
            </div>
            <input
              type="text"
              className="input w-full border flex-1 field"
              placeholder="Nom & Prénom(s) du père"
              value={president['nom-pere']}
              onChange={(e) => handleInputChange("nom-pere", e.target.value)}
            />
          </div>
          <div className="intro-y col-span-12 sm:col-span-6">
            <div className="mb-2">Nom & Prénom(s) de la mère   {props.demande === "commerciale" || props.demande === "civile"
                ? " de l'Administration"
                : " du président"}</div>
            <input
              type="text"
              className="input w-full border flex-1 field"
              placeholder="Nom & Prénom(s) de la mère"
              value={president['nom-mere']}
              onChange={(e) => handleInputChange("nom-mere", e.target.value)}
            />
          </div>
        </div>
      </div>

      <div
        className="intro-y col-span-12 flex items-center justify-center
                sm:justify-end mt-10"
      >
        <button
          className="button w-24 justify-center block bg-gray-200 text-gray-600 
                dark:bg-dark-1 dark:text-gray-300"
          onClick={props.handleQuestionnaireBackClick ?? null}
        >
          Revenir
        </button>
        <button
          className="button w-24 justify-center block bg-theme-1 
                text-white ml-2"
          onClick={handleStepSubmit}
        >
          Suivant
        </button>
      </div>
    </div>
  );
}
